/* eslint-disable no-bitwise */

/**
 * Gera um uuid da versão quatro com valores aleatórios
 */
export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Idenfitica o navegador utilizado
 * @returns
 */
export const getBrowserReference = () => {
  const ua = navigator.userAgent;
  let tem;
  let M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return `IE ${tem[1] || ''}`;
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null)
      return tem
        .slice(1)
        .join(' ')
        .replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(' ');
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent;
  const width = window.innerWidth;
  if (/Mobi|Android/i.test(userAgent) || width <= 768) {
    return 'Mobile';
  } else if (/Tablet|iPad/i.test(userAgent) || (width > 768 && width <= 1024)) {
    return 'Tablet';
  } else {
    return 'Desktop';
  }
};
